module.exports = __webpack_public_path__ + "static/media/Reservations_Completed.009c8792.png";